// 2023/01/11 Leading Win 教育機能対応 DXWEBEFN00100_新規入場・送り出し教育 start
import styled from 'styled-components';

export default styled.section``;

export const NewentrantSendoffStyled = styled.div`
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom: 53px;
  .header-group {
    padding: 10px 32px 10px 32px;
    border-radius: 8px;
    background-color: #ffffff;
    box-shadow: var(--box-shadow);
    margin-top: 20px;
  }
  .header-left-button {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: none;
    font-size: 30px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    float: left;
    background: #939393;
    border: 0px;
  }

  .header-tiltle {
    display: flex;
    justify-content: center;
    font-weight: bold;
    font-size: 17px;
    color: #000000;
  }

  .header-tiltle-left {
    font-weight: bold;
    font-size: 17px;
    color: #000000;
  }

  .form-group {
    background-color: #ffffff;
    box-shadow: var(--box-shadow);
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e0e0e0;
  }

  .form-group-tiltle {
    border: 1px solid #e0e0e0;
    padding: 5px 10px 5px 10px;
    background-color: #3b80be;
    box-shadow: var(--box-shadow);
    color: #ffffff;
    font-weight: bold;
    font-size: 17px;
  }
  .form-col {
    padding: 5px 5px 5px 5px;
  }
  .textarea {
    width: 100%;
    height: 250px;
    border: 1px solid #e0e0e0;
  }

  .form-col-left {
    display: flex;
    align-items: center;
    border-right: 1px solid #e0e0e0;
    padding: 5px 5px 5px 5px;
    width: 20%;
  }

  .form-col-right {
    padding: 5px 5px 5px 5px;
    width: 80%;
  }

  .form-left {
    border-right: 1px solid #e0e0e0;
    width: 8%;
  }
  .form-center {
    border-right: 1px solid #e0e0e0;
    width: 12%;
  }
  .form-right {
    border-right: 1px solid #e0e0e0;
    width: 80%;
  }

  .align-center {
    display: flex;
    align-items: center;
  }

  .display-flex {
    display: flex;
  }

  .border-bottom {
    border-bottom: 1px solid #e0e0e0;
  }

  .width-half {
    width: 50%;
  }

  .width-all {
    width: 100%;
  }

  .margin-top {
    margin-top: 20px;
  }
  .justify-content {
    display: flex;
    justify-content: center;
  }
  .color-red {
    color: red;
  }
  .border-radius-top {
    border-radius: 8px 8px 0px 0px;
  }

  .border-radius-bottom {
    border-radius: 0px 0px 8px 8px;
  }

  .select-field {
    width: 300px;
  }
  .input-field {
    border: 1px solid #e6e6e6;
    border-radius: 4px
    width: 100%;
  }
  .left_check{
    width: 30px;
    border-right: 1px solid #e0e0e0;
  }

  .left_check_history{
    width: 45%;
    border-right: 1px solid #e0e0e0;
  }

  .left_check_else{
    width: 45%;
  }

  .white-space{
    white-space: pre;
  }

  .ant-checkbox-disabled {
    .ant-checkbox-inner {
      background: #b3b3b3;
    }
  }

  .ant-select-disabled {
    background: #f5f5f5;
  }
`;
// 2023/01/11 Leading Win 教育機能対応 DXWEBEFN00100_新規入場・送り出し教育 end
